import CasinoResultPage from "./casino-result-page";

export default CasinoResultPage